import styled from '@emotion/styled'
import React, { useCallback, useEffect } from 'react'
import { useDispatch } from 'react-redux'

import { EmptyButton } from '../Button'
import { Card } from '../Card'
import { Flex } from '../Flex'
import { Icon } from '../Icon'
import { Layout } from '../Layout'
import { H4, Text } from '../Typography'

import { durations, removeError, TError } from './store'

const ToastContainer = styled(Card)`
  max-width: 400px;
  &.enter {
    opacity: 0;
  }
  &.enter-active {
    transition: opacity 0.4s ease;
    opacity: 1;
  }
  &.exit {
    opacity: 1;
  }
  &.exit-active {
    opacity: 0;
    transition: opacity 0.4s ease;
  }
`

type TProps = {
  error: TError
}

export const Toast = ({ error }: TProps) => {
  const dispatch = useDispatch()

  const remove = useCallback(() => {
    dispatch(removeError(error.id))
  }, [dispatch, error])

  useEffect(() => {
    let timeout: null | NodeJS.Timeout = null
    if (error.duration) timeout = setTimeout(remove, durations[error.duration])

    return () => {
      timeout && clearTimeout(timeout)
    }
  }, [])

  return (
    <ToastContainer position="relative" bg={error.type} shadow p={2} mb={2}>
      <Layout spacing={1} direction="row" alignItems="center">
        {error.icon ? (
          <Flex width={24} justifyContent="center">
            <Icon color="lights.4" icon={['fas', error.icon]} />
          </Flex>
        ) : null}
        <Layout direction="column" spacing={1}>
          <H4 color="lights.4">{error.title}</H4>
          <Text color="lights.4">{error.description}</Text>
        </Layout>
      </Layout>
      <EmptyButton position="absolute" top={2} right={2} onClick={remove}>
        <Icon color="lights.4" icon={['fas', 'times']} />
      </EmptyButton>
    </ToastContainer>
  )
}
